import React, { useState } from 'react';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Col, Row, Modal, Button } from 'antd';
import api from './images/api.svg';
import driver from './images/driver2.svg';
import time from './images/time-management.svg';
import { Link } from 'react-router-dom';
import Demo from './Demo';
import { useTranslation } from "react-i18next";

export default function Platform() {
  const [t, i18n] = useTranslation('global');
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <ScrollOverPack id="platform" className="content-wrapper page">
      <QueueAnim className="text-plaform" key="text" leaveReverse type="bottom">
        <h1 style={{ fontSize: '50px', color: 'black' }}>{t('Platform.title-ecos')}</h1>
        <p style={{ fontSize: '20px', color: 'grey', fontWeight: 'bold' }}>
        {t('Platform.platform')}{' '}
          <span style={{ color: '#423e3e', fontSize: '22px' }}>{t('Platform.saas')}</span> {t('Platform.text')}
          <br />
          <Link onClick={showModal}>{t('Platform.click')}</Link>
        </p>
        <Modal
          title={t('Demo.title-demo')}
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="submit" type="default" onClick={handleCancel}>
              {t('Platform.close')}
            </Button>,
          ]}
        >
          <Demo />
        </Modal>
      </QueueAnim>
      <div className="c-platform">
        <Row gutter={24} align="top">
          <Col xs={24} sm={24} md={12} lg={12} xl={9} span={24}>
            <img src={driver} className="img-plat1" alt="driver" />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={15} span={24}>
            <ul className="c-platform-list">
              <li>{t('Platform.real-time')}.</li>
              <li>{t('Platform.create-routes')}.</li>
              <li>{t('Platform.services-automatic')}.</li>
            </ul>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={12} lg={12} xl={9} span={18}>
            <img src={api} className="img-plat2" alt="api" />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={15} span={18}>
            <ul className="c-platform-list">
              <li>{t('Platform.integration-api')}.</li>
              <li>{t('Platform.notifications')}.</li>
              <li>{t('Platform.pickup-dinamic')}.</li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={9} span={6}>
            <img className="img-plat3" src={time} alt="driver" />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={15} span={6}>
            <ul className="c-platform-list">
              <li>{t('Platform.config-shift')}.</li>
              <li>{t('Platform.schedules')}.</li>
              <li>{t('Platform.geofences')}.</li>
            </ul>
          </Col>
        </Row>
      </div>
    </ScrollOverPack>
  );
}
